import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BackendObjectRef } from '../lib/backend-integration.service';
import { State } from '../lib/state.model';
import { SelectControlGroup } from '../lib/workflow-editor.store';

export interface WorkflowStateFormOptions {
  availableRoles: SelectControlGroup<BackendObjectRef>[];
  item: State;
}

export type WorkflowStateFormResult = WorkflowStateFormValue|string|undefined;

interface WorkflowStateFormValue {
  name: any;
  canDeleteRoles: any;
}
type WorkflowFormFieldFormControls = WorkflowStateFormValue;

@Component({
    selector: 'eas-workflow-state-form',
    templateUrl: './state-form.component.html',
    styleUrls: ['./state-form.component.css'],
    standalone: false
})
export class WorkflowStateFormComponent implements OnDestroy {
  public readonly form: FormGroup;
  public readonly availableRoles: SelectControlGroup<BackendObjectRef>[];

  private readonly dialogRef: MatDialogRef<WorkflowStateFormOptions, WorkflowStateFormResult>;
  private readonly destroyed$ = new Subject<void>();

  public item: State;

  constructor(fb: FormBuilder,
              @Inject(MAT_DIALOG_DATA) data: WorkflowStateFormOptions,
              dialogRef: MatDialogRef<WorkflowStateFormOptions, WorkflowStateFormResult>) {
    this.dialogRef = dialogRef;
    this.availableRoles = data.availableRoles;
    this.item = data.item;

    const controls: WorkflowFormFieldFormControls = {
      name: [data.item.name, Validators.required],
      canDeleteRoles: [data.item.canDeleteRoles]
    };
    this.form = fb.group(controls);

    this.form.valueChanges
             .pipe(takeUntil(this.destroyed$))
             .subscribe(_value => {
               try {
               } catch (_error) { }
             });
  }

  //
  // Lifecycle
  //

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }


  //
  // Actions
  //

  public onSave(): void {
    this.dialogRef.close(this.form.value);
  }

  public onCancel(): void {
    this.dialogRef.close(undefined);
  }

  public onDelete(): void {
    this.dialogRef.close(this.item.id);
  }

  //
  // Template helpers
  //

  // Compare function for mat-select to handle objects
  public compareOptionsByID(o1: any, o2: any) {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }
}
